import { UserVehicleData, VehicleData } from '@oneaudi/user-vehicle-feature-service';

interface HasPwd {
  hasPwd: boolean;
}
const useHasPwdVehicle = (userVehicles: UserVehicleData[]): HasPwd => {
  let hasPwd: boolean;

  if (userVehicles) {
    const vehicleList: VehicleData[] = [];
    userVehicles.map((vehicle: UserVehicleData | any) => vehicleList?.push(vehicle.vehicle));
    hasPwd = vehicleList.some((val) => {
      return val?.pdw?.pdwVehicle;
    });
    return { hasPwd };
  }
  hasPwd = false;
  return { hasPwd };
};

export default useHasPwdVehicle;
